import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AuthService, SharedService } from '@app/core';
import { AppGlobals } from '@app/app.global';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Probanker Simulation';

  constructor(
    private translateService: TranslateService,
    private sharedService: SharedService,
    private authService: AuthService,
    private appGlobals: AppGlobals,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.sharedService.getLanguages().subscribe(() => this.translateServiceInit());
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const route = this.getChild(this.route);
      route.data.subscribe(data =>
        this.titleService.setTitle('Probanker Simulation | ' + data.title)
      );
    });
  }

  getChild(route: ActivatedRoute) {
    if (route.firstChild) {
      return this.getChild(route.firstChild);
    } else {
      return route;
    }
  }

  translateServiceInit() {
    if (localStorage.getItem('probankerCurrentLanguage')) {
      this.translateService.use(localStorage.getItem('probankerCurrentLanguage'));
    } else {
      const browserLanguage = this.translateService.getBrowserCultureLang();

      const languageCodes = this.sharedService.languagesSubject.value.map(
        lang => lang.code + '-' + this.appGlobals.defaultLocale
      );

      const defaultLanguage = this.appGlobals.defaultLanguage + '-' + this.appGlobals.defaultLocale;

      const currentLanguage =
        this.authService.user &&
        this.authService.user.configuredLanguage &&
        (this.authService.user.configuredLanguage + '-' + this.appGlobals.defaultLocale).match(
          new RegExp(languageCodes.join('|'), 'gi')
        )
          ? this.authService.user.configuredLanguage + '-' + this.appGlobals.defaultLocale
          : browserLanguage.match(new RegExp(languageCodes.join('|'), 'gi'))
            ? browserLanguage
            : defaultLanguage;

      this.translateService.addLangs(languageCodes);
      this.translateService.setDefaultLang(defaultLanguage);
      if (currentLanguage) {
        this.translateService.use(currentLanguage);
        localStorage.setItem('probankerCurrentLanguage', currentLanguage);
      } else {
        this.translateService.use(defaultLanguage);
        localStorage.setItem('probankerCurrentLanguage', defaultLanguage);
      }
    }
  }
}
